import { useNavigate, useLocation } from "react-router-dom";

import { generate_queries, generate_item, updateMetaTags, reversed, checkItemExists } from "../script.js";
import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import Card from 'react-bootstrap/Card';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


export default function More(props) {
    const navigate = useNavigate();

    const [queries, setqueries] = useState([]);

    const urlParams = new URLSearchParams(useLocation().search);

    let stream_title = urlParams.get('title');
    let keywords = urlParams.get('keywords');

    let lastGuid = urlParams.get('last');
    let lastIndex = urlParams.get('index');

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip">
            {props}
        </Tooltip>
    );


    useEffect(() => {
        updateMetaTags();
        const loadingIndicator = document.getElementById('loading');
        const spinnerOverlay = document.getElementById('spinner-overlay');

        console.log("title: " + stream_title + " Keywords: " + keywords)

        if (stream_title == null || stream_title == "" || keywords == null || keywords == "") {
            alert("Please enter a title and keywords to explore any topic instantly");
            navigate("/streams");
        }

        if (!props.loggedInEmail) {
            alert("You must be logged in to use this feature");
            // Redirect back to main
            navigate("/account");
        }

        document.getElementById("keyword-field").textContent = keywords;
        generate_queries(stream_title, keywords, loadingIndicator, spinnerOverlay).then((new_queries) => {
            let querylist = [];
            for (let response in new_queries.responses) {
                querylist.push(new_queries.responses[response]);
            }
            setqueries(querylist);
        })
    }, []);

    async function navigateBackOnClick(event) {
        // Redirect back after making sure the last GUID is valid
        const itemExists = await checkItemExists(lastGuid);
        if (itemExists) {
            navigate(`/?item=${lastGuid}&index=${lastIndex}`, { replace: true });
        } else {
            alert("Error: item does not exist")
        }
    }

    async function tellMeMoreOnClick(query) {
        const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
        /*global uuid*/
        const guid = uuid.v5(query, NAMESPACE_URL);

        if (query !== '') {
            document.getElementById('spinner-overlay').style.display = 'flex';
            const encodedQuery = encodeURIComponent(query);

            const itemExists = await checkItemExists(guid);
            if (!itemExists) {
                await generate_item(encodedQuery, null, document.getElementById('loading'), document.getElementById('spinner-overlay'));
            }
            navigate(`/?item=${guid}&last=${lastGuid}&index=${lastIndex}`, { replace: true });
            window.location.reload();
        }
    }


    return (
        <div className="content-div">
            <div className="stream-view">
                <h3 id="title-field">{stream_title} </h3>
                <p id="keyword-field">{keywords}</p>
                <hr style={{ height: "4px", width: "100%" }} />
                <div id="table_items" className="stream-table">
                    {reversed(queries).map((query, i) => {
                        return <Card>
                            <div className={'stream-table-row ' + (i % 2 != 0 ? 'dark-background' : '')}>
                                <div className="stream-table-center" onClick={() => tellMeMoreOnClick(query)}>
                                    <h6>{query}</h6>
                                </div>
                            </div>
                        </Card>
                    })}
                </div>
                <p id="no_items" hidden> No items added to stream </p>
            </div>

            {lastGuid && lastIndex ?
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Back to item")}
                >
                    < button className="fixed-button upper-lower-left-button" onClick={() => { navigateBackOnClick() }}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button >
                </OverlayTrigger > : null
            }

            <span id="loading" className="center-screen" style={{ display: "none" }}>Loading...</span>

            {/* <!-- Spinner overlay --> */}
            <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
                <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
                <span id="loading" className="center-screen-lower" style={{ display: "none", marginTop: "20px", backgroundColor: "white" }}>Loading...</span>
            </div>
        </div>
    );
}